import { Box, Card, Typography } from '@mui/material';
import React from 'react';
import useWallet from '../../../../hooks/useWallet';
import { fCurrency } from '../../../../utils/formatNumber';

function WalletCard({ handleNavigate }) {
  const { saldoServicio, saldoPaqueteria, saldoRecarga } = useWallet();
  return (
    <Card onClick={handleNavigate} sx={{ padding: '10px', cursor: 'pointer', marginTop: '10px' }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
        <Typography fontSize="13px" variant="subtitle2">
          Saldo servicios:
        </Typography>
        <Typography fontSize="14px">{fCurrency(saldoServicio)}</Typography>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
        <Typography fontSize="13px" variant="subtitle2">
          Saldo paqueteria:
        </Typography>
        <Typography fontSize="14px">{fCurrency(saldoPaqueteria)}</Typography>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr' }}>
        <Typography fontSize="13px" variant="subtitle2">
          Saldo recarga:
        </Typography>
        <Typography fontSize="14px">{fCurrency(saldoRecarga)}</Typography>
      </Box>
    </Card>
  );
}

export default WalletCard;
